import { createSelector } from '@reduxjs/toolkit';

import { dataSourceTypeDescriptionSelector } from 'src/selectors/dataSourceTypeDescription';
import { Connection } from 'src/store/connections/types';

export const dataSourceTypesSelector = (connection: Connection | null) =>
  createSelector(
    dataSourceTypeDescriptionSelector(connection),
    (typeDescription) => typeDescription.DATA_SOURCE_TYPES
  );
